import whatsapp from '../api/whatsapp';
export default {
    namespaced: true,
    state: {
        messages : [],
        error    : '',
        activeChat : true,
        receiver : true,
    },
    getters: {
        getMessages: (state)  => {
            return state.messages
          },
          getActiveChat: (state)  => {
            return state.activeChat;
          },
          getErrorMessage: (state)  => {
            return state.error;
          },
          getReceiver: (state)  => {
            return state.receiver;
          }

    },
    mutations: {
        setMessages(state,messages) {
            state.activeChat = true;
            state.messages = messages;
        },
        setError(state,error) {
            state.activeChat = false;
            state.error = error;
        },
        setReceiver(state,receiver) {
            state.receiver = receiver;       
        },
        addMessage(state,message) {
           state.messages.push({
                content: message.body,
                me: true,
                created_at: new Date().toLocaleString()
            });
        }
    },
    actions: {
        postMessage ({ commit },data) {
            whatsapp.postMessages(data).then(response => {
                commit('addMessage',response.data.message);
              })
          },
          getMessages({commit},data) {
            whatsapp.getAllMessages(data).then(response => {
                if(response.data.status == "success") {
                    commit('setMessages',response.data.data.messages);
                    commit('setReceiver',response.data.data.receiver);
                }else {
                    commit('setError',response.data.message);
                }
            })
          }
    },
}